var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.499979 0.500021C0.361792 0.638208 0.361796 0.861835 0.499979 1.00002L3.49996 4L0.499979 6.99998C0.361793 7.13817 0.361796 7.3618 0.499979 7.49998C0.638162 7.63816 0.861793 7.63816 0.999976 7.49998L3.99996 4.5L6.99994 7.49998C7.13813 7.63817 7.36175 7.63816 7.49994 7.49998C7.63812 7.3618 7.63812 7.13817 7.49994 6.99998L4.49996 4L7.49994 1.00002C7.63812 0.861831 7.63812 0.638204 7.49994 0.500021C7.36175 0.361838 7.13812 0.361838 6.99994 0.500021L3.99996 3.5L0.999976 0.500021C0.86179 0.361834 0.638162 0.361838 0.499979 0.500021Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseWhite);
export default __webpack_public_path__ + "static/media/close-white.38c5e7fe40f7ef3d3e0cd0d96ed22a46.svg";
export { ForwardRef as ReactComponent };